// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__nseU0","content":"RecentSearches_content__2Tw9i"};